function TOOLS_LINK() {
    if (window.location.hostname.includes("localhost")) {
        console.log("have localhost: ", window.location.hostname);
        return 'http://localhost:3000/';
    } else {
        if (window.location.hostname.includes("mioga-integration.oga.com.bo")) {
            return 'https://herramientas.oga.com.bo/';
        } else {
            if (window.location.hostname.includes("mioga.oga.com.bo")) {
                return 'https://herramientas.oga.com.bo/';
            }
            return "";
        }
    }
}
export default TOOLS_LINK();



// WEBPACK FOOTER //
// ./src/utils/HttpClient/toolsLink.js